<template>
  <div class="row">
    <div class="col">
      <v-card class="py-4 px-4" outlined color="transparent">
        <div v-if="subscription">
          <v-alert
            v-if="subscription.cancel_at_period_end"
            outlined
            type="error"
            text
            border="left"
          >
            <h3>Subscription Cancelled</h3>
            <p>
              This subscription will cancel at the end of the period. Open
              billing portal to renew your plan
            </p>
          </v-alert>

          <v-alert v-cloak outlined type="info" prominent border="bottom">
            <h3>Your Current Subscription Plan</h3>
            <p>
              <strong>
                Payment type:
              </strong>
              {{
                subscription.items[0].plan.interval === 'year'
                  ? 'Annual'
                  : 'Monthly'
              }}
              recurring payments
              <br />
              <span v-if="subscription.current_period_end">
                <strong>
                  Payment due:
                </strong>
                {{
                  new Date(
                    subscription.current_period_end.seconds * 1000
                  ).toLocaleString()
                }}
              </span>
            </p>

            <!-- <p v-if="subscription.current_period_start">
              Plan Started:
              {{
                new Date(
                  subscription.current_period_start.seconds * 1000
                ).toLocaleString()
              }}
            </p> -->
          </v-alert>
        </div>

        <v-btn
          color="primary"
          :disabled="isLoading"
          @click="openCustomerPortal"
        >
          {{ isLoading ? 'Loading...' : this.planText }}
        </v-btn>
      </v-card>
    </div>
  </div>
</template>

<script>
import { functions } from 'firebase/app' // Importing the 'app' module instead
import 'firebase/functions' // Importing the 'functions' module

export default {
  props: ['subscription'],

  data() {
    return {
      planText: 'Manage subscription',
      isLoading: false,
      portalUrl: null // New data property to store the portal URL
    }
  },

  methods: {
    async openCustomerPortal() {
      this.isLoading = true
      try {
        const createPortalLink = functions().httpsCallable(
          'ext-firestore-stripe-payments-createPortalLink'
        )
        const { data } = await createPortalLink({
          returnUrl: window.location.href
        })

        this.portalUrl = data.url
        window.location.href = this.portalUrl
      } catch (error) {
        console.error('Error opening customer portal:', error)
        this.isLoading = false
        // Handle errors here
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>
